import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { GewerkeSection } from './components/GewerkeSection';
import { AboutSection } from './components/AboutSection';
import { WhyKalemSection } from './components/WhyKalemSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { Impressum } from './components/Impressum';
import { Datenschutz } from './components/Datenschutz';
import { AGB } from './components/AGB';
import { AdminDashboard } from './components/AdminDashboard';
import { CookieBanner } from './components/CookieBanner';
import { Toaster } from './components/ui/sonner';

const HomePage = () => {
  return (
    <>
      <Header />
      <HeroSection />
      <GewerkeSection />
      <AboutSection />
      <WhyKalemSection />
      <ContactSection />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/admin/anfragen" element={<AdminDashboard />} />
        </Routes>
        <CookieBanner />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;